import { MESSAGE_FORMAT, MESSAGE_HIRAGANA_FORMAT, MESSAGE_MAXLENGTH_CUSTOM, MESSAGE_REQUIRED } from '@/constants/messageRequired';
import { initValidation } from '@/validation';
import { ERROR_FIELD_IDS, FIELD_NAMES } from './constants';

const contactValidationSchema = {
    rules: {
        [FIELD_NAMES.REQUEST_TYPE]: {
            required: true
        },
        [FIELD_NAMES.REQUEST_DETAIL]: {
            required: true,
            requiredNoWhitespace: true,
            maxlength: 2000
        },
        [FIELD_NAMES.CUSTOMER_TYPE]: {
            required: true
        },
        [FIELD_NAMES.NAME]: {
            required: true,
            requiredNoWhitespace: true
        },
        [FIELD_NAMES.NAME_KANA]: {
            required: true,
            requiredNoWhitespace: true,
            hiraganaFormat: true
        },
        [FIELD_NAMES.EMAIL]: {
            required: true,
            requiredNoWhitespace: true,
            strictEmail: true
        },
        [`${FIELD_NAMES.PHONE}1`]: {
            required: true,
            requiredNoWhitespace: true,
            phoneFormat: true,
            phoneConditionalRequired: true
        },
        [`${FIELD_NAMES.PHONE}2`]: {
            required: true,
            requiredNoWhitespace: true,
            phoneFormat: true,
            phoneConditionalRequired: true
        },
        [`${FIELD_NAMES.PHONE}3`]: {
            required: true,
            requiredNoWhitespace: true,
            phoneFormat: true,
            phoneConditionalRequired: true
        },
        [`${FIELD_NAMES.FAX}1`]: {
            phoneFormat: true,
            faxConditionalRequired: true
        },
        [`${FIELD_NAMES.FAX}2`]: {
            phoneFormat: true,
            faxConditionalRequired: true
        },
        [`${FIELD_NAMES.FAX}3`]: {
            phoneFormat: true,
            faxConditionalRequired: true
        },
        [`${FIELD_NAMES.POSTAL_CODE}1`]: {
            postalCodeFormatNoRequiredRule: true
        },
        [`${FIELD_NAMES.POSTAL_CODE}2`]: {
            postalCodeFormatNoRequiredRule: true
        },
        [FIELD_NAMES.URL_HOMEPAGE]: {
            strictUrl: true
        }
    },
    messages: {
        [FIELD_NAMES.REQUEST_TYPE]: {
            required: `お問い合わせ種別${MESSAGE_REQUIRED}`,
            requiredNoWhitespace: `お問い合わせ種別${MESSAGE_REQUIRED}`
        },
        [FIELD_NAMES.REQUEST_DETAIL]: {
            required: `お問い合わせ内容${MESSAGE_REQUIRED}`,
            requiredNoWhitespace: `お問い合わせ内容${MESSAGE_REQUIRED}`,
            maxlength: `お問い合わせ内容は${MESSAGE_MAXLENGTH_CUSTOM(2000)}`
        },
        [FIELD_NAMES.CUSTOMER_TYPE]: {
            required: `お客様区分${MESSAGE_REQUIRED}`
        },
        [FIELD_NAMES.NAME]: {
            required: `お名前${MESSAGE_REQUIRED}`,
            requiredNoWhitespace: `お名前${MESSAGE_REQUIRED}`
        },
        [FIELD_NAMES.NAME_KANA]: {
            required: `ふりがな${MESSAGE_REQUIRED}`,
            requiredNoWhitespace: `ふりがな${MESSAGE_REQUIRED}`,
            hiraganaFormat: `ふりがな${MESSAGE_HIRAGANA_FORMAT}`
        },
        [FIELD_NAMES.EMAIL]: {
            required: `メールアドレス${MESSAGE_REQUIRED}`,
            requiredNoWhitespace: `メールアドレス${MESSAGE_REQUIRED}`,
            strictEmail: `${MESSAGE_FORMAT.EMAIL}`
        },
        [`${FIELD_NAMES.PHONE}1`]: {
            required: `電話番号${MESSAGE_REQUIRED}`,
            requiredNoWhitespace: `電話番号${MESSAGE_REQUIRED}`,
            phoneFormat: `${MESSAGE_FORMAT.PHONE}`,
            phoneConditionalRequired: `電話番号${MESSAGE_REQUIRED}`
        },
        [`${FIELD_NAMES.PHONE}2`]: {
            required: `電話番号${MESSAGE_REQUIRED}`,
            requiredNoWhitespace: `電話番号${MESSAGE_REQUIRED}`,
            phoneFormat: `${MESSAGE_FORMAT.PHONE}`,
            phoneConditionalRequired: `電話番号${MESSAGE_REQUIRED}`
        },
        [`${FIELD_NAMES.PHONE}3`]: {
            required: `電話番号${MESSAGE_REQUIRED}`,
            requiredNoWhitespace: `電話番号${MESSAGE_REQUIRED}`,
            phoneFormat: `${MESSAGE_FORMAT.PHONE}`,
            phoneConditionalRequired: `電話番号${MESSAGE_REQUIRED}`
        },
        [`${FIELD_NAMES.FAX}1`]: {
            phoneFormat: `${MESSAGE_FORMAT.FAX}`,
            faxConditionalRequired: `${MESSAGE_FORMAT.FAX}`
        },
        [`${FIELD_NAMES.FAX}2`]: {
            phoneFormat: `${MESSAGE_FORMAT.FAX}`,
            faxConditionalRequired: `${MESSAGE_FORMAT.FAX}`
        },
        [`${FIELD_NAMES.FAX}3`]: {
            phoneFormat: `${MESSAGE_FORMAT.FAX}`,
            faxConditionalRequired: `${MESSAGE_FORMAT.FAX}`
        },
        [`${FIELD_NAMES.POSTAL_CODE}1`]: {
            postalCodeFormatNoRequiredRule: `${MESSAGE_FORMAT.POSTAL_CODE}`
        },
        [`${FIELD_NAMES.POSTAL_CODE}2`]: {
            postalCodeFormatNoRequiredRule: `${MESSAGE_FORMAT.POSTAL_CODE}`
        },
        [FIELD_NAMES.URL_HOMEPAGE]: {
            strictUrl: 'URLの形式が正しくありません。'
        }
    }
};

export const initContactValidation = (formContainer, options = {}) => {
    const { errorDisplay = {}, submitHandler } = options;

    return initValidation(formContainer, contactValidationSchema, {
        errorDisplay: {
            mode: 'field',
            autoClearing: true,
            onChangeValidation: true,
            fieldMapping: ERROR_FIELD_IDS,
            ...errorDisplay
        },
        submitHandler: submitHandler || (() => {})
    });
};
